export default "__VITE_ASSET__BC2g9i6h__"